<template>
    <div class="main-wrapper">
      <div>
        <!-- Header and Breadcrumbs -->
        <layout-header></layout-header>
        <breadcrumb40></breadcrumb40>
  
        <!-- Page Content -->
        <div class="content">
          <div class="container">
            <div class="row">
              <!-- Sidebar -->
              <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                <sidebar></sidebar>
              </div>
  
              <!-- Patient Info Card and Tabs -->
              <div class="col-md-7 col-lg-8 col-xl-9">
                <!-- Patient Info Card -->
                <div class="card-wrapper ml-lg-4">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <!-- Profile Image -->
                        <div class="col-md-2">
                          <img class="encounter-image"
                        v-bind:src="dashboard_data.patient_image ? config.base_url_for_Image + dashboard_data.patient_image : loadImg('Patient Profile.svg')"
                        alt="User Image" />
                        </div>
  
                        <!-- Patient Details -->
                        <div class="col-md-4">
                          <h5><strong>{{ dashboard_data.patient_name }}</strong></h5>
                          <p style="font-size: smaller;">-- yrs / {{ dashboard_data.gender }}</p>
                          <p style="font-size: smaller;">Language - {{ dashboard_data.language }}</p>
                          <p style="font-size: smaller;">
                            <strong>Appointment Status</strong> : <span style="font-weight: bold; color: darkblue;">{{ dashboard_data.status }}</span>
                          </p>
                          <p style="font-size: smaller;"><strong>Treatment Update</strong> : --</p>
                        </div>
  
                        <!-- Patient Condition -->
                        <div class="col-md-3">
                          <p style="font-size: smaller;">
                            <strong>Knee Pain / Hip Pain Since</strong>: --
                          </p>
                          <p style="font-size: smaller;"><strong>Diagnosis</strong> : --</p>
                          <p style="font-size: smaller;"><strong>Advise</strong></p>
                          <!-- <button class="btn btn-sm mt-1" style="background-color: #f8f8f8;">Dropdown on last slide</button>
                          <button class="btn btn-sm mt-1" style="background-color: #f8f8f8;">Dropdown on last slide</button> -->
                        </div>
  
                        <!-- Actions and Fee -->
                        <div class="col-md-3">
                          <div class="actions">
                            <button class="btn btn-success btn-sm">Click to Call</button>
                            <button class="btn btn-primary btn-sm">Action</button>
                            <button class="btn btn-danger btn-sm">SOS</button>
                          </div>
                          <p style="font-size: 13px;">
                            <strong>Home Visit Fee</strong> : ₹ --
                            <button class="btn btn-info btn-sm">Paid</button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
                <!-- Tabs Section -->
                <div class="tabs-container ml-lg-4">
                  <ul class="nav nav-tabs">
                    <li class="nav-item" v-for="tab in tabs" :key="tab.name">
                      <a
                        class="nav-link ml-lg-2"
                        :class="{ active: currentTab === tab.name }"
                        @click.prevent="currentTab = tab.name"
                        href="#"
                        >{{ tab.label }}</a
                      >
                    </li>
                  </ul>
                </div>
  
                <!-- Dynamic Component Rendering Based on Tab -->
                <div class="tab-content card ml-lg-4 p-lg-3">
                  <!-- Render the component based on the selected tab -->
                  <component :is="currentTabComponent" :patient_id="dashboard_data.patient_id"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
        <layout-footer></layout-footer>
      </div>
    </div>
  </template>
  
  <script>
  import CommonApi from "../../../services/CommonApi";
  import config from "../../../services/CommonApi";
  import Datepicker from "vuejs-datepicker";
  import VueTimepicker from "vue2-timepicker";
  import "vue2-timepicker/dist/VueTimepicker.css";
  const images = require.context("@/assets/img/patients");
  export default {
    components: {
      Datepicker,
      VueTimepicker
    },
    computed: {
      currentTabComponent() {
            // Find the current tab and return its component
            const currentTab = this.tabs.find(tab => tab.name === this.currentTab);
            return currentTab ? currentTab.component : null;
          }
        },  
    data() {
      return {

        currentTab: 'Present History', // Default active tab
        tabs: [
          { name: 'Present History', label: 'Present History', component: () => import('@/components/kneexpert/Tabs/Details.vue'),props: { patient_id: this.$route.params.patient_id }},
          { name: 'Joint Assessment', label: 'Joint Assessment', component: () => import('@/components/kneexpert/Tabs/JointAssessment.vue'),props: { patient_id: this.$route.params.patient_id }},
          { name: 'X MRI Assessment', label: 'X MRI Assessment', component: () => import('@/components/kneexpert/Tabs/Assessment.vue'),props: { patient_id: this.$route.params.patient_id }},
          { name: 'prediction', label: 'Prediction', component: () => import('@/components/kneexpert/Tabs/Prediction.vue'),props: { patient_id: this.$route.params.patient_id }},
          { name: 'Advice', label: 'Advice', component: () => import('@/components/kneexpert/Tabs/TreatmentAdvice.vue'),props: { patient_id: this.$route.params.patient_id }},
          { name: 'old history', label: 'Old History', component: () => import('@/components/kneexpert/Tabs/History.vue'),props: { patient_id: this.$route.params.patient_id }},
          { name: 'old reports', label: 'Old Reports', component: () => import('@/components/kneexpert/Tabs/Reports.vue'),props: { patient_id: this.$route.params.patient_id }}
        ],
        showPlusIcon: true,
        showMedicalPlusIcon:true,
        showSurgeryAdvice:true,
        showGenralAdvice:true,
        showExerciseAdvice:true,
        showExamination:true,
        showSensorium:true,
        showSystem:true,
        patient_age: "",
        practitioner_names: "Sunil Jain",
        practitioner_name: "",
        selectedOption: 'age',
        doc_status: "",
        attachmentUrl: null,
        format: "dd-MM-yyyy",
        showspinner: true,
        disabled_template_button: true,
        active: "Details",
        new_complaint: "",
        config:config,
        new_labtest: "",
        new_diagnosis: "",
        new_surgery: "",
        dashboard_data: {
          patient_image: "",
          patient_id: this.$route.params.patient_id,
          appointment_id: this.$route.params.appointment_id,
          patient_name: "",
          patient_mobile: "",
          dob: "",
          encounter_date: this.convertDate(new Date()),
          encounter_time: "",
          gender: "",
          visit_type: "",
          patient_history: "",
          patient_symptoms: "",
        },
      }
    },
    mounted() {
      let user = localStorage.getItem("userInfo");
      if (!user) {
        this.$router.push({ name: 'login' })
      }
      if (this.$route.params.encounter_id) {
        this.get_patient_encounter_data();
      }
      this.get_patient_profile();
    
      //sidebar open close
      var $wrapper = $(".main-wrapper");
      $(".main-nav a").on("click", function (e) {
        if (
          $(this)
            .parent()
            .hasClass("has-submenu")
        ) {
          e.preventDefault();
        }
        if (!$(this).hasClass("submenu")) {
          $("ul", $(this).parents("ul:first")).slideUp(350);
          $("a", $(this).parents("ul:first")).removeClass("submenu");
          $(this)
            .next("ul")
            .slideDown(350);
          $(this).addClass("submenu");
        } else if ($(this).hasClass("submenu")) {
          $(this).removeClass("submenu");
          $(this)
            .next("ul")
            .slideUp(350);
        }
      });
      $("body").append('<div class="sidebar-overlay"></div>');
      $(document).on("click", "#mobile_btn", function () {
        $wrapper.toggleClass("slide-nav");
        $(".sidebar-overlay").toggleClass("opened");
        $("html").addClass("menu-opened");
        $("#task_window").removeClass("opened");
        return false;
      });
  
      $(document).on("click", "#menu_close", function () {
        $("html").removeClass("menu-opened");
        $(".sidebar-overlay").removeClass("opened");
        $("main-wrapper").removeClass("slide-nav");
      });
      $(".main-nav ul li:not(.submenu) a").click(function () {
        $("html").removeClass("menu-opened");
        $(".sidebar-overlay").removeClass("opened");
      });
    },
    //sidebar open close
  
    destroyed() {
      this.$store.dispatch("user/closedAppointment");
    },
    methods: {
    /* Convert Date to Required Format for API */
    convertDate(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
      }
    },
      
    async get_patient_encounter_data() {
      const params = new URLSearchParams();
      params.append("name", this.$route.params.encounter_id);
      await CommonApi.get_data(
        "sahaj.api.get_patient_encounter_data",
        params
      ).then((res) => {
        if (res.data[0].patient_age) {
          this.patient_age = res.data[0].patient_age.substring(0, 17);
        } else {
          this.patient_age = '';
        }
        // this.patient_age = res.data[0].patient_age;
        this.practitioner_names = res.data[0].practitioner_name;
        this.practitioner_name = res.data[0].practitioner;
        this.dashboard_data.patient_image = res.data[0].image;
        this.patient_therapy_plan_template = res.data[0].therapy_plan_template;
        this.patient_exercise = res.data[0].exercise;
        this.dashboard_data.visit_type = res.data[0].mode;
        this.dashboard_data.encounter_date = this.convertDate(
          res.data[0].encounter_date
        );
        this.dashboard_data.encounter_time = res.data[0].encounter_time;
        this.doc_status = res.data[0].docstatus;

        this.dashboard_data.visit_type = res.data[0].mode;
        this.dashboard_data.patient_history =
          res.data[0].patient_came_with_history;

        if (res.data[0].my_symptoms.length) {
          this.complaint = [];
          res.data[0].my_symptoms.map((item) =>
            this.complaint.push({
              complaint: item.my_symptoms,
            })
          );
        }

        this.examination_data.pallor = res.data[0].pallor;
        this.examination_data.cyanosis = res.data[0].cyanosis;
        this.examination_data.edema = res.data[0].edema;
        this.examination_data.hydration = res.data[0].hydration;
        this.examination_data.icterus = res.data[0].icterus;
        this.examination_data.clubbing = res.data[0].clubbing;
        this.examination_data.dysponea = res.data[0].dysponea;
        this.examination_data.thyroid = res.data[0].thyroid;
        this.examination_data.lymphadenopathy = res.data[0].lymphadenopathy;
        this.examination_data.jvp = res.data[0].jvp;
        this.examination_data.examination_of_breast =
          res.data[0].examination_of_breast;
        this.examination_data.eye_opening = res.data[0].eye_opening;
        this.examination_data.verbal_response = res.data[0].verbal_response;
        this.examination_data.motor_response = res.data[0].motor_response;
        this.examination_data.score = res.data[0].score;
        this.examination_data.cardiovascular_system =
          res.data[0].cardiovascular_system;
        this.examination_data.central_nervous_system =
          res.data[0].central_nervous_system;
        this.examination_data.abdomen = res.data[0].abdomen;
        this.examination_data.respiratory_system =
          res.data[0].respiratory_system;
        this.examination_data.local_examination = res.data[0].local_examination;


        // add assessment data 
        this.pain_analysis_data.knee_xray_diagnosis_left = res.data[0].knee_xray_diagnosis_left;
        this.pain_analysis_data.knee_xray_diagnosis_right = res.data[0].knee_xray_diagnosis_right;
        this.pain_analysis_data.deformity_left = res.data[0].deformity_left;
        this.pain_analysis_data.deformity_right = res.data[0].deformity_right;
        this.pain_analysis_data.xray_diagnosis_remarks = res.data[0].xray_diagnosis_remarks;
        this.pain_analysis_data.mri_diagnosis_left = res.data[0].mri_diagnosis_left;
        this.pain_analysis_data.mri_diagnosis_right = res.data[0].mri_diagnosis_right;
        this.pain_analysis_data.mri_assessment_remarks = res.data[0].mri_assessment_remarks;
        this.pain_analysis_data.svf_left = res.data[0].svf_left;
        this.pain_analysis_data.svf_right = res.data[0].svf_right;
        this.pain_analysis_data.pfo_left = res.data[0].pfo_left;
        this.pain_analysis_data.pfo_right = res.data[0].pfo_right;
        this.pain_analysis_data.hto_left = res.data[0].hto_left;
        this.pain_analysis_data.hto_right = res.data[0].hto_right;
        this.pain_analysis_data.dfo_left = res.data[0].dfo_left;
        this.pain_analysis_data.dfo_right = res.data[0].dfo_right;
        this.pain_analysis_data.arthroscopy_left = res.data[0].arthroscopy_left;
        this.pain_analysis_data.arthoscopy_right = res.data[0].arthoscopy_right;



        if (res.data[0].pain_analysis.length) {
          this.pain_analysis = [];
          res.data[0].pain_analysis.map((item) =>
            this.pain_analysis.push({
              joint: item.joint,
              location: item.location,
              intensity: item.intensity,
              nature: item.nature,
              period: item.period,
              pain_since: item.pain_since,
              timing: item.timing,
            })
          );
        }

        if (res.data[0].injury_history.length) {
          this.injury_history = [];
          res.data[0].injury_history.map((item) =>
            this.injury_history.push({
              injury_type: item.injury_type,
              year: item.year,
            })
          );
        }

        if (res.data[0].assistive_device_using.length) {
          this.assistive_device_using = [];

          res.data[0].assistive_device_using.map((item) =>
            this.assistive_device_using.push({
              assistive_device: item.assistive_device_using,
            })
          );
        } else {
          this.assistive_device_using.push({
            assistive_device: "",
          });
        }

        this.assistive_device_using[0].period = res.data[0].period;
        this.assistive_device_using[0].days = res.data[0].days;

        this.joint_data.knee = res.data[0].knee ? true : false;
        this.joint_data.knee_location = res.data[0].knee_location;
        this.joint_data.hip = res.data[0].hip ? true : false;
        this.joint_data.hip_location = res.data[0].knee_location;
        this.joint_data.ankle = res.data[0].ankle ? true : false;
        this.joint_data.ankle_location = res.data[0].ankle_location;
        this.joint_data.foot = res.data[0].foot ? true : false;
        this.joint_data.foot_location = res.data[0].foot_location;
        this.joint_data.cervical_spine = res.data[0].cervical_spine
          ? true
          : false;
        this.joint_data.lumbar_spine = res.data[0].lumbar_spine ? true : false;
        this.joint_data.shoulder = res.data[0].shoulder ? true : false;
        this.joint_data.shoulder_location = res.data[0].shoulder_location;
        this.joint_data.elbow = res.data[0].elbow ? true : false;
        this.joint_data.elbow_location = res.data[0].elbow_location;
        this.joint_data.forearm = res.data[0].forearm ? true : false;
        this.joint_data.forearm_location = res.data[0].forearm_location;
        this.joint_data.wrist = res.data[0].wrist ? true : false;
        this.joint_data.wrist_location = res.data[0].wrist_location;
        this.joint_data.finger = res.data[0].finger ? true : false;
        this.joint_data.pain_scale = res.data[0].pain_scale;
        this.joint_assessment_id = res.data[0].joint_assessment;

        if (this.joint_data.knee) {
          this.selected_joint = "Knee";
        } else if (this.joint_data.hip) {
          this.selected_joint = "Hip";
        } else if (this.joint_data.ankle) {
          this.selected_joint = "Ankle";
        } else if (this.joint_data.foot) {
          this.selected_joint = "Foot";
        } else if (this.joint_data.shoulder) {
          this.selected_joint = "Shoulder";
        } else if (this.joint_data.elbow) {
          this.selected_joint = "Elbow";
        } else if (this.joint_data.forearm) {
          this.selected_joint = "Forearm";
        } else if (this.joint_data.wrist) {
          this.selected_joint = "Wrist";
        }

        // if (res.data[0].lab_test_prescription.length) {
        //   this.lab_test = [];
        //   res.data[0].lab_test_prescription.map((item) =>
        //     this.lab_test.push({
        //       lab_test_code: item.lab_test_name,
        //     })
        //   );
        // }

        // this.advise = res.data[0].advise;
        // (this.exercise_advice = res.data[0].exercise_advice),
        //   (this.prescription = res.data[0].prescription);

        (this.selected_investigation_template =
          res.data[0].investigation_advice),
          (this.selected_exercise_advice_template =
            res.data[0].exercise_advice),
          (this.selected_surgery_template = res.data[0].surgery_advice),
          (this.selected_prescription_template = res.data[0].prescription),
          (this.selected_general_advice_template = res.data[0].advise);

        // if (res.data[0].procedure_prescription.length) {
        //   this.surgery_template = [];
        //   res.data[0].procedure_prescription.map((item) =>
        //     this.surgery_template.push({
        //       procedure: item.procedure,
        //     })
        //   );
        // }

        if (res.data[0].encounter_diagnosis.length) {
          this.diagnosis = [];
          res.data[0].encounter_diagnosis.map((item) =>
            this.diagnosis.push({
              diagnosis: item.encounter_diagnosis,
            })
          );
        }

        if (this.joint_assessment_id !== null) {
          this.get_joint_assessment_details(this.joint_assessment_id);
        }
      });
    },
  
      formatDate(dateString) {
        if (!dateString) {
          return "";
        }
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
  
      formatDate(dateString) {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString().slice(-2);
        return `${day}-${month}-${year}`;
      },
    
  
      loadImg(imgPath) {
        return images("./" + imgPath);
      },

      /* Get Patient Profile */
      async get_patient_profile() {
        const params = new URLSearchParams();
        params.append("name", this.$route.params.patient_id);
        await CommonApi.get_data(
          "sahaj.finalapi.get_patient_profile",
          params
        ).then((res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.dashboard_data.patient_name = res.data.patient_name;
            this.dashboard_data.patient_mobile = res.data.mobile;
            this.dashboard_data.gender = res.data.sex;
            this.dashboard_data.dob = res.data.dob;
            this.dashboard_data.language = res.data.language;
            this.dashboard_data.status = res.data.status;
          }
        });
      },

    },
  };
  </script>
  
  <style scoped>
  .card {
    border: 1px solid #ddd;
    border-radius: 5px;
    box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.1);
  }
  
  .card-body {
    padding: 20px;
  }
  
  .profile-img {
    width: 100px;
    height: 100px;
  }
  
  .actions {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  
  .actions .btn {
    margin-right: 10px;
    margin-bottom: 5px;
  }
  
  h5 {
    font-size: 18px;
  }
  
  p {
    margin: 5px 0;
  }
  
  .tabs-container {
    margin-top: 20px;
  }
  
  .nav-tabs .nav-item .nav-link {
    color: #333;
    border-radius: 5px;
    font-size: 14px;
  }
  
  .nav-tabs .nav-item .nav-link.active {
    background-color: #66CDAA;
    color: white;
  }
  
  .tab-content {
    margin-top: 20px;
  }


@media (max-width: 768px) {

  .tabs-container ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-left:10px;
  padding-right: 10px;
  padding-bottom: 20px;
}

.tabs-container ul li {
  flex: 1 0 100%; /* Full width on desktop */
  text-align: center;
}

  .tabs-container ul li {
    flex: 1 0 50%; /* 3 tabs per row on mobile */
    text-align: left;
    margin-top: 20px;
  }
}

  </style>
  


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/Test.vue